import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { LOCAL_STORAGE } from "../constants/local-storage";
import { LocalStoreService } from "../services/local-store.service";
import { LoginService } from "../services/login.service";

@Injectable()
export class AuthCheckGuard implements CanActivate {

  constructor(
    private router: Router,
    private ls: LocalStoreService,
    private loginService: LoginService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // return true;
    const user = await this.ls.getItem(LOCAL_STORAGE.APP_USER);
    if (user) {
      this.router.navigateByUrl('/');
      return true;
    }
    return true;
  }
}
